import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href = '#compra',
  className = ''
}: ButtonProps) {
  const baseClasses = 'relative overflow-hidden group bg-[#D4A017] hover:bg-[#E8B830] border-2 border-[#E8B830]/60 text-black font-extrabold py-4 px-6 md:px-8 rounded-2xl text-lg md:text-2xl flex items-center justify-center gap-3 transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_rgba(212,160,23,0.45),0_0_80px_rgba(212,160,23,0.15)] w-full max-w-2xl mx-auto uppercase tracking-wider';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <a href={href} onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-305">
      <span className="relative z-10 text-center" data-id="element-306">{children}</span>
      <ArrowRight className="w-6 h-6 md:w-8 md:h-8 relative z-10 group-hover:translate-x-2 transition-transform flex-shrink-0" data-id="element-307" />
      <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 group-hover:animate-[shine_1s]" data-id="element-308" />
    </a>;
}